import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-622110db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-ui-mb15" }
const _hoisted_2 = { class: "patch-info cm-ui-mb15" }
const _hoisted_3 = { class: "info-line" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = {
  class: "info-line",
  style: {"display":"flex"}
}
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { style: {"display":"inline-flex"} }
const _hoisted_8 = { class: "info-line" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "status" }

import { computed, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import CmTable from '@/components/cmTable/index.vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { LeakViewService, TerminalList } from '../leak-view-table.service'
import type { LeakList } from '@/views/dashboard/safe-status/vulnerability-fix/vulnerability-fix.service'
import { computerInfoCols } from '@/views/dashboard/data-safe/ransomware-protection/types/ransomware-incident'
import type { TableOpt } from '@/components/cmTable/types'
import { resolvedVirusKbDescription } from '@/utils/virus-kb-description'


export default /*#__PURE__*/_defineComponent({
  __name: 'repair-drawer',
  props: {
    currentLeak: {}
  },
  setup(__props: any) {

const props = __props

const { t, te, locale } = useI18n()

const injector = useReflectiveInjector([LeakViewService])
const service = injector.get(LeakViewService)

const tableRef = ref<{
  tableRef?: { clearSelection: () => void }
  getList?: (...args: unknown[]) => void | Promise<unknown>
} | null>(null)
const { refreshList } = useCmTableListRefresh(tableRef)

const form = reactive({
  kb_number: props.currentLeak?.kb_number ?? '',
})

const pageOption = {
  pageNumName: 'page',
  pageSizeName: 'limit',
}

const multipleSelection = ref<TerminalList[]>([])

const isCveKb = computed(() => (props.currentLeak?.kb_number ?? '').includes('CVE-'))

const leakKbDescDisplay = computed(() => {
  void locale.value
  const kb = props.currentLeak?.kb_number
  const desc = props.currentLeak?.kb_desc
  return resolvedVirusKbDescription(kb, te, t) ?? desc ?? ''
})

function kbNumberDisplay(kb: string | undefined | null) {
  const s = kb ?? ''
  if (!s) return '—'
  return s.includes('CVE-') ? s : `KB${s}`
}

const fixStatusMap = computed(() => ({
  0: t('safeProtectionModule.notRepaired'),
  1: t('safeProtectionModule.repairing'),
}))

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    showActionBar: false,
    showSearch: false,
    showRightToolbar: false,
    disableScrollLoad: false,
    usePagination: false,
    bodyStyle:{padding:'15px'},
    height: '100%',
    path: 'list',
    totalPath: 'total',
    selection: !isCveKb.value,
    rowKey: 'device_id',
    reserveSelection: false,
    columns: [
      ...computerInfoCols(false, true, t, { mac: false }),
      { prop: 'os', label: t('safeProtectionModule.os'), minWidth: 190  },
      { prop: 'scan_time', label: t('safeProtectionModule.detectTime'), minWidth: 160  },
      { prop: 'fix_status', label: t('safeProtectionModule.fixStatus'), minWidth: 120  },
    ],
  }
})

function getListApi(params: Record<string, unknown>) {
  return service.getTerminals({
    kb_number: String(params.kb_number ?? form.kb_number),
    page: Number(params.page ?? 1),
    limit: Number(params.limit ?? 20),
  })
}

function onChangeSelected(selection: TerminalList[]) {
  multipleSelection.value = selection
}

watch(
  () => props.currentLeak?.kb_number,
  async (kb) => {
    form.kb_number = kb ?? ''
    multipleSelection.value = []
    tableRef.value?.tableRef?.clearSelection?.()
    await refreshList()
  },
)

async function repairTerminal() {
  const kb = props.currentLeak?.kb_number ?? form.kb_number
  if (!kb) return
  try {
    await service.repairLeak({
      kb_number: kb,
      device_list: multipleSelection.value.map((item) => item.device_id),
    })
    ElMessage.success(t('safeProtectionModule.repairCmdSuccess'))
    multipleSelection.value = []
    tableRef.value?.tableRef?.clearSelection?.()
  } catch {
    ElMessage.error(t('safeProtectionModule.repairCmdFail'))
    multipleSelection.value = []
    tableRef.value?.tableRef?.clearSelection?.()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_date_format = _resolveDirective("date-format")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    modelValue: form,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
    "table-opt": tableOpt.value,
    api: getListApi,
    "page-option": pageOption,
    onChangeSelected: onChangeSelected
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('safeProtectionModule.patchNumberLabel')) + ": ", 1),
            _createTextVNode(_toDisplayString(kbNumberDisplay(_ctx.currentLeak.kb_number)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('safeProtectionModule.leakDesc')), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(leakKbDescDisplay.value), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('safeProtectionModule.leakLevel')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.currentLeak.warn_level ? _ctx.$t('safeProtectionModule.leakHigh') : _ctx.$t('safeProtectionModule.leakOptional')), 1)
          ])
        ]),
        (!isCveKb.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              disabled: !multipleSelection.value.length,
              onClick: repairTerminal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.repairLeakBtn')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    scan_time: _withCtx(({ row }) => [
      _withDirectives(_createElementVNode("span", null, null, 512), [
        [_directive_date_format, { value: row.scan_time * 1000 }]
      ])
    ]),
    fix_status: _withCtx(({ row }) => [
      _createElementVNode("span", _hoisted_10, _toDisplayString(fixStatusMap.value[row.fix_status] ?? '—'), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "table-opt"]))
}
}

})